/* Mon p'tit pitchou — scripts du thème */
(function () {
  'use strict';
  var P = window.pitchou || { routes: {}, textes: {} };
  var R = P.routes, T = P.textes;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var fmt = new Intl.NumberFormat(P.locale === 'de' ? 'de-DE' : 'fr-FR', { style: 'currency', currency: 'EUR' });
  var argent = function (c) { return fmt.format(c / 100); };
  var verrou = function (on) { document.documentElement.style.overflow = on ? 'hidden' : ''; };

  /* ---------- Toast ---------- */
  var toastMinuterie;
  function toast(msg) {
    var t = $('.toast'); if (!t) return;
    t.textContent = msg; t.classList.add('visible');
    clearTimeout(toastMinuterie); toastMinuterie = setTimeout(function () { t.classList.remove('visible'); }, 2600);
  }

  /* ---------- Menu mobile ---------- */
  var menu = $('[data-tiroir-menu]');
  function ouvrirMenu(o) {
    if (!menu) return;
    menu.classList.toggle('est-ouvert', o); verrou(o);
    $$('[data-ouvrir-menu]').forEach(function (b) { b.setAttribute('aria-expanded', o); });
    if (o) { var f = $('a,summary,button', menu.querySelector('.menu-m')); if (f) f.focus(); }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ouvrir-menu]')) { ouvrirMenu(true); }
    else if (e.target.closest('[data-fermer-menu]')) { ouvrirMenu(false); }
  });

  /* ---------- Recherche ---------- */
  var zoneR = $('[data-recherche]'), champR = $('[data-champ-recherche]'), resR = $('[data-resultats-recherche]');
  function ouvrirRecherche(o) {
    if (!zoneR) return;
    zoneR.classList.toggle('est-ouverte', o); verrou(o);
    $$('[data-ouvrir-recherche]').forEach(function (b) { b.setAttribute('aria-expanded', o); });
    if (o && champR) setTimeout(function () { champR.focus(); }, 30);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ouvrir-recherche]')) { e.preventDefault(); ouvrirRecherche(true); }
    else if (e.target.closest('[data-fermer-recherche]')) { ouvrirRecherche(false); }
  });
  var minR, ctrlR;
  if (champR && resR) {
    champR.addEventListener('input', function () {
      clearTimeout(minR);
      var q = champR.value.trim();
      if (q.length < 2) { resR.innerHTML = ''; return; }
      minR = setTimeout(function () {
        if (ctrlR) ctrlR.abort();
        ctrlR = window.AbortController ? new AbortController() : null;
        fetch(R.suggestion + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', ctrlR ? { signal: ctrlR.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!prods.length) { resR.innerHTML = '<p class="petit">' + T.aucun + '</p>'; return; }
            var h = '<ul role="list">';
            prods.forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
              h += '<li><a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" width="56" height="56" loading="lazy">' : '<span></span>') +
                '<span class="t">' + p.title.replace(/</g, '&lt;') + '</span><span class="p">' + argent(Math.round(parseFloat(p.price) * 100)) + '</span></a></li>';
            });
            h += '</ul><p style="margin:10px 0 0"><a class="lien-fleche" href="/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q) + '">' + T.voirTout + ' →</a></p>';
            resR.innerHTML = h;
          }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- Panier ---------- */
  var tiroir = $('[data-tiroir-panier]');
  function ouvrirPanier(o) {
    tiroir = $('[data-tiroir-panier]');
    if (!tiroir) return;
    tiroir.classList.toggle('est-ouvert', o); verrou(o);
  }
  function majCompteur(n) {
    $$('[data-compteur]').forEach(function (c) { c.textContent = n; c.hidden = !n; });
  }
  function rafraichirPanier() {
    return fetch((R.racine || '/') + '?sections=panier-tiroir', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var wrap = document.getElementById('shopify-section-panier-tiroir');
        var ouvert = tiroir && tiroir.classList.contains('est-ouvert');
        if (wrap && d['panier-tiroir']) {
          var tmp = document.createElement('div'); tmp.innerHTML = d['panier-tiroir'];
          var neuf = tmp.querySelector('[data-tiroir-panier]');
          var ancien = $('[data-tiroir-panier]');
          if (neuf && ancien) { if (ouvert) neuf.classList.add('est-ouvert'); ancien.replaceWith(neuf); tiroir = neuf; }
        }
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (c) { majCompteur(c.item_count); return c; });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-ouvrir-panier]');
    if (o && !document.body.classList.contains('gabarit-cart')) { e.preventDefault(); ouvrirPanier(true); return; }
    if (e.target.closest('[data-fermer-panier]')) { ouvrirPanier(false); return; }
    var l = e.target.closest('[data-ligne]');
    if (l) {
      e.preventDefault();
      var zone = l.closest('.ligne-panier'); if (zone) zone.style.opacity = '.5';
      fetch(R.changer + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: l.dataset.ligne, quantity: parseInt(l.dataset.qte, 10) }) })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (document.body.classList.contains('gabarit-cart')) { location.reload(); return; }
          return rafraichirPanier();
        })
        .catch(function () { if (zone) zone.style.opacity = ''; toast(T.erreur); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { ouvrirPanier(false); ouvrirMenu(false); ouvrirRecherche(false); fermerLoupe(); fermerFiltres(); }
  });

  function ajouter(form, bouton) {
    var fd = new FormData(form);
    if (bouton) { bouton.setAttribute('aria-busy', 'true'); bouton.disabled = true; }
    return fetch(R.ajout + '.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { return rafraichirPanier(); })
      .then(function () { ouvrirPanier(true); })
      .catch(function (err) { toast((err && (err.description || err.message)) || T.erreur); })
      .then(function () { if (bouton) { bouton.removeAttribute('aria-busy'); bouton.disabled = false; } });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-ajout-panier]') || f.getAttribute('id') === 'form-produit') {
      if (!window.fetch) return;
      e.preventDefault();
      ajouter(f, f.querySelector('[type=submit]'));
    }
  });

  /* ---------- Carrousels ---------- */
  function majFleches(piste) {
    var p = $('[data-carrousel-prec="' + piste.id + '"]'), s = $('[data-carrousel-suiv="' + piste.id + '"]');
    if (p) p.disabled = piste.scrollLeft < 8;
    if (s) s.disabled = piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 8;
  }
  $$('.carrousel__piste').forEach(function (piste) {
    if (!piste.id) return;
    piste.addEventListener('scroll', function () { majFleches(piste); }, { passive: true });
    majFleches(piste);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-carrousel-prec],[data-carrousel-suiv]');
    if (!b) return;
    var piste = document.getElementById(b.dataset.carrouselPrec || b.dataset.carrouselSuiv);
    if (!piste) return;
    var sens = b.hasAttribute('data-carrousel-prec') ? -1 : 1;
    piste.scrollBy({ left: sens * piste.clientWidth * 0.9, behavior: 'smooth' });
  });

  /* ---------- Collection : tri et filtres ---------- */
  var tri = $('[data-tri]');
  if (tri) tri.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', tri.value); u.searchParams.delete('page'); location.href = u.toString();
  });
  var filtres = $('[data-filtres]');
  function fermerFiltres() { if (filtres && filtres.classList.contains('est-ouvert')) { filtres.classList.remove('est-ouvert'); verrou(false); } }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ouvrir-filtres]') && filtres) { filtres.classList.add('est-ouvert'); verrou(true); }
    else if (e.target.closest('[data-fermer-filtres]')) fermerFiltres();
  });
  var formF = $('[data-form-filtres]');
  if (formF) {
    formF.addEventListener('change', function (e) {
      if (e.target.matches('[data-auto]') && window.matchMedia('(min-width: 990px)').matches) formF.requestSubmit ? formF.requestSubmit() : formF.submit();
    });
    formF.addEventListener('submit', function () {
      $$('input', formF).forEach(function (i) { if ((i.type === 'number' || i.type === 'hidden') && i.value === '') i.disabled = true; });
    });
  }
  var entete = $('.section-entete');
  if (entete) {
    var majH = function () { document.documentElement.style.setProperty('--haut-entete', entete.offsetHeight + 'px'); };
    majH(); window.addEventListener('resize', majH, { passive: true });
  }

  /* ---------- Fiche produit ---------- */
  var fiche = $('[data-produit]');
  var loupe = $('[data-loupe-zone]');
  function fermerLoupe() { if (loupe && loupe.classList.contains('est-ouverte')) { loupe.classList.remove('est-ouverte'); verrou(false); } }
  if (fiche) {
    var form = $('#form-produit');
    var variantes = []; try { variantes = JSON.parse($('[data-variantes]').textContent); } catch (e) {}
    var images = []; try { images = JSON.parse($('[data-images]').textContent); } catch (e) {}
    var piste = $('[data-galerie-piste]', fiche);
    var diapos = piste ? $$('.galerie__diapo', piste) : [];
    var points = $$('.galerie__points span', fiche);
    var vignettes = $$('[data-vignette]', fiche);
    var idx = $('[data-galerie-index]', fiche);

    function allerA(i, doux) {
      if (!piste || !diapos[i]) return;
      piste.scrollTo({ left: diapos[i].offsetLeft - piste.offsetLeft, behavior: doux === false ? 'auto' : 'smooth' });
    }
    if (piste) {
      var majIndex = function () {
        var i = Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth));
        if (idx) idx.textContent = i + 1;
        points.forEach(function (p, k) { p.classList.toggle('actif', k === i); });
        vignettes.forEach(function (v, k) { v.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      };
      piste.addEventListener('scroll', function () { window.requestAnimationFrame(majIndex); }, { passive: true });
    }
    vignettes.forEach(function (v) { v.addEventListener('click', function () { allerA(parseInt(v.dataset.vignette, 10)); }); });

    /* Loupe */
    fiche.addEventListener('click', function (e) {
      var b = e.target.closest('[data-loupe]');
      if (!b || !loupe) return;
      var cible = $('[data-loupe-images]', loupe);
      if (!cible.childElementCount) cible.innerHTML = images.map(function (u, k) { return '<img src="' + u + '" alt="" loading="' + (k < 2 ? 'eager' : 'lazy') + '">'; }).join('');
      loupe.classList.add('est-ouverte'); verrou(true);
      var im = cible.children[parseInt(b.dataset.loupe, 10)];
      if (im) setTimeout(function () { im.scrollIntoView(); }, 30);
    });
    if (loupe) loupe.addEventListener('click', function (e) { if (e.target.closest('[data-fermer-loupe]') || e.target.tagName === 'IMG') fermerLoupe(); });

    /* Quantité */
    var qte = form ? $('input[name=quantity]', form) : null;
    fiche.addEventListener('click', function (e) {
      if (!qte) return;
      if (e.target.closest('[data-qte-moins]')) qte.value = Math.max(1, (parseInt(qte.value, 10) || 1) - 1);
      if (e.target.closest('[data-qte-plus]')) qte.value = Math.min(10, (parseInt(qte.value, 10) || 1) + 1);
    });

    /* Variantes */
    function choisie() {
      var opts = [];
      $$('.option', form).forEach(function (fs, k) {
        var c = $('input[data-option]:checked', fs); opts[k] = c ? c.value : null;
      });
      return variantes.filter(function (v) { return v.options.every(function (o, k) { return opts[k] === null || opts[k] === undefined || o === opts[k]; }); })[0];
    }
    function majVariante(v) {
      if (!v) return;
      $('[data-variante-id]', form).value = v.id;
      $$('[data-prix]').forEach(function (el) { el.textContent = argent(v.price); });
      var eco = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price - v.price : 0;
      var barre = $('[data-prix-barre]', fiche), ecoEl = $('[data-eco]', fiche), badge = $('[data-badge-eco]', fiche);
      if (barre) { barre.hidden = !eco; var bv = $('[data-prix-barre-valeur]', barre); if (bv && eco) bv.textContent = argent(v.compare_at_price); }
      if (ecoEl) { ecoEl.hidden = !eco; if (eco) $('[data-eco-valeur]', ecoEl).textContent = argent(eco); }
      if (badge) { badge.hidden = !eco; if (eco) badge.textContent = '−' + argent(eco).replace(/[,.]00(?=\s?€)/, ''); }
      var prixP = $('.prix', fiche); if (prixP) prixP.classList.toggle('prix--promo', !!eco);
      var pf = $('[data-paiement-fois]', fiche);
      if (pf) {
        var n = parseInt(pf.dataset.n, 10) || 3;
        pf.hidden = v.price < +pf.dataset.min || v.price > +pf.dataset.max;
        var m = $('[data-mensualite]', pf); if (m) m.textContent = argent(Math.floor(v.price / n));
      }
      var dispo = $('[data-dispo]', fiche), bt = $('[data-bouton-ajout]', fiche), btT = $('[data-bouton-texte]', fiche), barreBt = $('[data-barre-ajout]');
      if (dispo) { dispo.textContent = v.available ? T.enStock : T.epuise; dispo.classList.toggle('dispo--non', !v.available); }
      if (bt) bt.disabled = !v.available;
      if (btT) btT.textContent = v.available ? T.ajouter : T.epuise;
      if (barreBt) barreBt.disabled = !v.available;
      $$('[data-option-choisie]', fiche).forEach(function (s, k) { s.textContent = v.options[k]; });
      if (v.featured_media) {
        var k = diapos.findIndex(function (d) { return d.dataset.mediaId == v.featured_media.id; });
        if (k > -1) allerA(k);
      }
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      majDispoOptions();
    }
    function majDispoOptions() {
      var fs = $$('.option', form);
      fs.forEach(function (f, k) {
        $$('input[data-option]', f).forEach(function (inp) {
          var sel = fs.map(function (ff, j) { var c = $('input[data-option]:checked', ff); return j === k ? inp.value : (c ? c.value : null); });
          var ok = variantes.some(function (v) { return v.available && v.options.every(function (o, j) { return sel[j] === null || o === sel[j]; }); });
          var lab = inp.nextElementSibling; if (lab) lab.classList.toggle('indispo', !ok);
        });
      });
    }
    if (form) {
      form.addEventListener('change', function (e) { if (e.target.matches('[data-option]')) majVariante(choisie()); });
      majDispoOptions();
    }

    /* Barre d'achat collante (mobile) */
    var barreA = $('[data-barre-achat]'), btA = $('[data-bouton-ajout]', fiche);
    if (barreA && btA && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var vis = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        barreA.classList.toggle('visible', vis); barreA.setAttribute('aria-hidden', !vis);
        $('[data-barre-ajout]', barreA).tabIndex = vis ? 0 : -1;
      }).observe(btA);
      $('[data-barre-ajout]', barreA).addEventListener('click', function () { if (form) ajouter(form, this); });
    }

    /* Livraison estimée */
    var liv = $('[data-livraison]', fiche);
    if (liv) {
      var ajoutOuvres = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var j = d.getDay(); if (j !== 0 && j !== 6) n--; } return d; };
      var prep = parseInt(liv.dataset.prep, 10) || 2, mn = parseInt(liv.dataset.min, 10) || 2, mx = parseInt(liv.dataset.max, 10) || 5;
      var auj = new Date();
      var d1 = ajoutOuvres(auj, prep + mn), d2 = ajoutOuvres(auj, prep + mx);
      var o = { weekday: 'short', day: 'numeric', month: 'short' };
      var loc = P.locale === 'de' ? 'de-DE' : 'fr-FR';
      var txt = $('[data-livraison-texte]', liv);
      if (txt) txt.textContent = (P.locale === 'de' ? 'Voraussichtliche Lieferung zwischen ' : 'Livraison estimée entre le ') + d1.toLocaleDateString(loc, o) + (P.locale === 'de' ? ' und ' : ' et le ') + d2.toLocaleDateString(loc, o);
    }
  }
})();
